"use strict";
exports.__esModule = true;
exports.FlexLinks = void 0;
var FlexLinks;
(function (FlexLinks) {
    FlexLinks["helpHome"] = "https://help.getflex.com/hc/en-us";
    FlexLinks["helpHomeTest"] = "https://getflex1741991897.zendesk.com/hc/en-us";
    FlexLinks["autopayAuthorization"] = "https://getflex.com/autopay-authorization";
    FlexLinks["noRentPortal"] = "https://help.getflex.com/hc/en-us/articles/360059675813";
    FlexLinks["termsOfService"] = "https://getflex.com/terms/";
    FlexLinks["esignConsent"] = "https://getflex.com/legal/esign-consent/";
    FlexLinks["appStore"] = "https://itunes.apple.com/us/app/avance-financial/id1458274896?ls=1&mt=8";
    FlexLinks["googlePlayStore"] = "https://play.google.com/store/apps/details?id=com.avance.consumer&hl=en_US";
    FlexLinks["privacyPolicy"] = "https://getflex.com/privacy/";
    FlexLinks["blueRidgeBankPrivacyPolicy"] = "https://www.mybrb.com/privacy-policy.html";
    FlexLinks["privacyNotice"] = "https://getflex.com/privacy-notice/";
    FlexLinks["membershipFeeLearnMore"] = "https://help.getflex.com/hc/en-us/articles/7870682642583";
    FlexLinks["selfPayMoreAccountInfo"] = "https://help.getflex.com/hc/en-us/articles/10096905080343";
    FlexLinks["flexAccountDisabledHelp"] = "https://help.getflex.com/hc/en-us/articles/360058968754";
    FlexLinks["notApprovedInfo"] = "https://help.getflex.com/hc/en-us/articles/360059675853";
    FlexLinks["phoneNumberFAQ"] = "https://help.getflex.com/hc/en-us/articles/16490157743639";
    FlexLinks["partnerPrivacy"] = "https://getflex.com/partner-privacy";
    FlexLinks["selfSubmittingYourRent"] = "https://help.getflex.com/hc/en-us/articles/9842401810455";
    FlexLinks["rentReportingFAQ"] = "https://help.getflex.com/hc/en-us/articles/14152585437719";
    FlexLinks["cardholderAgreement"] = "http://getflex.com/card-holder-agreement";
    FlexLinks["shortLongFormAgreement"] = "http://getflex.com/long-and-short-form-fee-schedules";
    FlexLinks["transUnionUnfreeze"] = "https://www.transunion.com/credit-freeze";
    FlexLinks["creditBuilderDisclosure"] = "https://getflex.com/renters/credit-builder/";
    FlexLinks["creditBuilderHelpCenter"] = "https://help.getflex.com/hc/en-us/articles/24315569851159";
    FlexLinks["creditBuilderCreditScore"] = "https://help.getflex.com/hc/en-us/articles/24315608516631";
    FlexLinks["flexApp"] = "https://onboarding.getflex.com/";
})(FlexLinks = exports.FlexLinks || (exports.FlexLinks = {}));
